var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"pointer top-left"}),_c('div',{staticClass:"pointer top-right"}),_c('div',{staticClass:"pointer bottom-left"}),_c('div',{staticClass:"pointer bottom-right"}),_c('img',{attrs:{"src":_vm.img,"alt":"banner"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }